export class NumberHelper {
	getNumberOrUndefined(value?: number): number | undefined {
		if (typeof value === 'number') {
			return value;
		}
		return undefined;
	}

	isOdd(number: number): boolean {
		return number % 2 === 1;
	}

	formatNumber(number: number): string {
		return number.toLocaleString();
	}
}

export const numberHelper = new NumberHelper();
